import { render, staticRenderFns } from "./smallCart.vue?vue&type=template&id=813e72f8&"
import script from "./smallCart.vue?vue&type=script&lang=js&"
export * from "./smallCart.vue?vue&type=script&lang=js&"
import style0 from "./smallCart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports